export const ALL_GROUPS = {
  ALL: 'all',
  SELECTION: 'selection',
} as const;

export const QUERY_KEYS = {
  categories: 'categories',
} as const;

export const PER_PAGE = 25;

export const HEADER_TAB_WIDTH = '100px';
